export const SIDEBAR_COLLAPSED_COOKIE = "pt-sidebar-collapsed";

export function sidebarCollapsedFromCookie(value?: string) {
  return value === "1";
}
